export enum OENRateSubscriptionState {
  PENDING,
  ACTIVE,
  DELETE,
}
